module.exports = __webpack_public_path__ + "h5/img/live-logo.cc9ce3d6.gif";